import React from 'react';
import { apiCreateComment, apiIsLoggedIn } from '../api/api';
import TopBarComment from '../components/topbars/TopBarComment';
import { useParams } from 'react-router-dom';
import ForumContentField from '../components/fields/ForumContentField';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class CreateCommentPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            content: '',
        };

        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handleCommentSubmit = this.handleCommentSubmit.bind(this);
    }
    
    async componentDidMount() {
        const isLoggedIn = await apiIsLoggedIn();
        if (!isLoggedIn) {
            window.location.href = '/';
        }
    }

    handleChangeContent(event) {
        this.setState({
            ...this.state,
            content: event.target.value,
        });
    }

    async handleCommentSubmit(event) {
        event.preventDefault();

        const result = await apiCreateComment(this.props.params.uuid, this.state.content);

        if (result.ok) {
            window.location.href = `/post/${this.props.params.uuid}`
        }
    }

    render() {
        return (
            <div>
                <TopBarComment postUuid={this.props.params.uuid} />
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                    <form onSubmit={this.handleCommentSubmit} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <ForumContentField value={this.state.content} onChange={this.handleChangeContent} />
                        <input type="submit" value="Submit" />
                    </form>
                </div>
            </div>
        )
    }
}

export default withParams(CreateCommentPage);
